import { useEffect, useState } from "react"
import { useAuthorization } from "~/components/AuthorizationProvider"
import { SettleMultiple } from "~/components/Transaction/SettleMultiple"
import { Permission } from "~/constants/Permissions"
import { useSettlementSelectorList } from "~/store/settlement-selector.store"

export const PlantSettlementAction = ({
  plant,
  isInvoice = false,
}: {
  plant: any
  isInvoice?: boolean
}) => {
  const canSettleMultiple = useAuthorization(
    Permission.CanSettleMultipleTradesAndInvoices
  )
  const { setModalOpen } = useSettlementSelectorList()
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    setModalOpen?.(isOpen)
  }, [isOpen])

  return canSettleMultiple ? (
    <>
      <div
        onClick={() => {
          setOpen(true)
        }}
        className="cursor-pointer underline"
      >
        {plant?.department?.name}
      </div>
      <SettleMultiple
        isInvoice={isInvoice}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        plant={plant}
      />
    </>
  ) : (
    plant?.department?.name
  )
}
